define('bizzabo/models/CreatedEventsCollection',['backbone', 'bizzabo/bzapi', 'bizzabo/models/EventDetails'], function(Backbone, BZAPI, EventDetails) {

    var CreatedEventsCollection = Backbone.Collection.extend({
        sync : function(method, model, options) {
            if (method == 'read') {
                BZAPI.getMyCreatedEvents(function(data) {
                    options.success && options.success(data, options);
                }, options.error);
            }
        },

        model : EventDetails,
        comparator : function(anEvent) {
            var start = anEvent.get('start-date');
            return start ? parseFloat(start) * (-1) : undefined;
        }
    });

    return CreatedEventsCollection;

});

